import { useGameStore } from '../state/store.js';

/** Shows details of the tile currently under the cursor. */
export const TileTooltip = (): React.JSX.Element | null => {
  const hovered = useGameStore((s) => s.hovered);
  if (!hovered) return null;

  return (
    <div className="panel tooltip">
      <div className="panel-title">
        Tile ({hovered.x}, {hovered.y})
      </div>
      <div className="row">
        <span className="row-label">Biome</span>
        <span className="row-value">{hovered.biome}</span>
      </div>
      <div className="row">
        <span className="row-label">Terrain</span>
        <span className="row-value">{hovered.terrain}</span>
      </div>
      <div className="row">
        <span className="row-label">Elevation</span>
        <span className="row-value">{hovered.elevation}</span>
      </div>
      <div className="row">
        <span className="row-label">Buildable</span>
        <span className={`row-value ${hovered.buildable ? 'good' : 'bad'}`}>
          {hovered.buildable ? 'yes' : 'no'}
        </span>
      </div>
    </div>
  );
};
